import { useEffect, useRef, useState } from 'react';
import Layout from '../components/Layout';
import api from '../services/api';

export default function MapView() {
  const mapRef = useRef(null);
  const [status, setStatus] = useState('Loading map…');
  const [error, setError] = useState('');

  useEffect(() => {
    let view;

    async function initMap() {
      try {
        // Get ArcGIS token from our backend
        const { data: auth } = await api.get('/arcgis/token');

        // Dynamically import ArcGIS SDK (large dependency, lazy loaded)
        const [
          { default: esriConfig },
          { default: esriId },
          { default: WebMap },
          { default: ArcMapView },
        ] = await Promise.all([
          import('@arcgis/core/config'),
          import('@arcgis/core/identity/IdentityManager'),
          import('@arcgis/core/WebMap'),
          import('@arcgis/core/views/MapView'),
        ]);

        const portalUrl = auth.orgUrl || 'https://www.arcgis.com';
        esriConfig.portalUrl = portalUrl;

        esriId.registerToken({
          server: `${portalUrl}/sharing/rest`,
          token: auth.token,
        });

        const webmap = new WebMap({
          portalItem: {
            id: process.env.REACT_APP_ARCGIS_WEBMAP_ID,
            portal: { url: portalUrl },
          },
        });

        view = new ArcMapView({
          container: mapRef.current,
          map: webmap,
        });

        await view.when();
        setStatus('');
      } catch (err) {
        console.error(err);
        setError('Failed to load map. Check your ArcGIS configuration.');
        setStatus('');
      }
    }

    initMap();
    return () => { if (view) view.destroy(); };
  }, []);

  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <div className="mb-4">
          <h1 className="text-xl font-bold text-gray-800">Map View</h1>
          <p className="text-sm text-gray-500">Project locations from ArcGIS Online</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" style={{ height: '70vh' }}>
          {status && (
            <div className="flex items-center justify-center h-full text-gray-400 text-sm">
              {status}
            </div>
          )}
          {error && (
            <div className="flex items-center justify-center h-full text-red-500 text-sm">
              {error}
            </div>
          )}
          <div ref={mapRef} className="w-full h-full" />
        </div>
      </div>
    </Layout>
  );
}
